export function isTotalPoolVisible(data) {
  if (!data) return false
  if (data.enabled === false) return false
  if (data.status != null && Number(data.status) === 0) return false
  return true
}

export function getTotalPoolSecondaryText(data, formatPeriodDays) {
  if (!data) return ''
  const periodDays = Number(data.periodDays)
  const hasPeriodDays = Number.isFinite(periodDays) && periodDays > 0
  const localizedPeriodLabel =
    hasPeriodDays && typeof formatPeriodDays === 'function' ? formatPeriodDays(periodDays) : ''
  const periodLabel = hasPeriodDays
    ? localizedPeriodLabel || String(periodDays)
    : data.periodLabel || ''
  return [data.subtitle, periodLabel].filter(Boolean).join(' · ')
}
